// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"LoadingPage_loadingPage__o_jEq","loadingContent":"LoadingPage_loadingContent__0vYRn"};